import { useState } from "react";
import { Grid } from "@mui/material";

import { useQuery } from "@tanstack/react-query";
import StickyHeadTable from "ui-components/tables/StickyTable";
import { getSerialNumberLog } from "services/data.inventory.service";
import Drawer from "ui-components/Drawer";

const columns = [
  { label: "Serial Number", id: "serialNo" },
];

function SerialNumberLog({ open, setOpen, logRequest, setLogRequest, setAlert }) {
  //const onError = (data) => setAlert(<Error data={data} onChange={setAlert} />);
  const [logs, setLogs] = useState(null);

  useQuery({
    queryKey: ["porecv-log", { logRequest }],
    queryFn: () => getSerialNumberLog(logRequest),
    enabled: logRequest !== null,
    onSuccess: (data) => {
      const item = data.data.data;

      setLogs(
        <>
          <div style={{ fontSize: "14px", marginBottom: "20px" }}>
            <Grid container>
              <Grid item xs={6}>
                <b>SKU Code : </b>
                {item.skuCode}
              </Grid>
              <Grid item xs={6}>
                <b>Product Name : </b>
                {item.descriptions1}
              </Grid>
              <Grid item xs={6}>
                <b>Quantity : </b>
                {item.quantity}
              </Grid>
              <Grid item xs={6}>
                <b>OLN : </b>
                {item.oln}
              </Grid>
              <Grid item xs={12}>
                <b>Location ID : </b>
                {item.locationID}
              </Grid>
            </Grid>
          </div>
          <div>
            <StickyHeadTable columns={columns} rows={item.serialNumbers} />
          </div>
        </>
      );
    },
    //onError,
  });

  const toggleDrawer = (open) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(open);
    setLogs(null);
    setLogRequest(null);
  };

  return (
    <Drawer width="800px" open={open} onClose={toggleDrawer(false)} onOpen={toggleDrawer(true)}>
      {logs}
    </Drawer>
  );
}

export default SerialNumberLog;
